/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('ConditionalTemplatesService',
    function (this: JS5Object, _: JS5Object,
              ConditionalTemplatesResourceFactory: JS5Object) {

        this.originalEditData = {};
        this.getAllConditionalTemplates = (queryParams: JS5Object, queryHandler: JS5Function) => {
            return ConditionalTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
        };
        this.getConditionalTemplate = (conditionalTemplateId: number) => {
            return ConditionalTemplatesResourceFactory.get({id: conditionalTemplateId}).$promise;
        };
        this.createConditionalTemplate = (conditionalTemplate: JS5Object) => {
            return ConditionalTemplatesResourceFactory.save(conditionalTemplate).$promise;
        };
        this.cloneConditionalTemplate = (conditionalTemplate: JS5Object) => {
            return ConditionalTemplatesResourceFactory.clone({id: conditionalTemplate.id}).$promise;
        };
        this.updateConditionalTemplate = (conditionalTemplate: JS5Object) => {
            return ConditionalTemplatesResourceFactory.update(conditionalTemplate).$promise;
        };
        this.deleteConditionalTemplate = (conditionalTemplateId: number) => {
            return ConditionalTemplatesResourceFactory.delete({id: conditionalTemplateId}).$promise;
        };
    });
